import { MutableRefObject, useContext, useEffect, useRef, useState } from "react";
import Overlay from "@alifd/next/lib/overlay";
import { BefMenuServiceContext, BefMessageServiceContext, BefRpcContext, IBefMenuElement } from "@beflam/bef-core";
import { AllFunctions } from "./allfunctions";
export class MenuOverlayProps {
    data: any;
}
export function MenuOverlay(props: MenuOverlayProps) {
    const [visible, setVisible] = useState<boolean>(false);
    const messageService = useContext(BefMessageServiceContext);
    const [menuData, setMenuData] = useState<any>([]);
    const onVisibleChange = (evt: any) => {
        setVisible(evt)
    }
    const refresh = async (_isShow: boolean = false) => {
        try {

            if (props.data) {
                let _datas: any[] = [];
                props.data.map((res: any) => {
                    if (res) {
                        let temp = res.Groups.filter((item: any) => item.ID !== "__starMenuGroup");
                        _datas = _datas.concat(temp);
                    }
                });
                setMenuData(_datas);
            };

        } catch (error) {
            messageService.showMessage(messageService.handleErr(error, "菜单获取"));
        }
    }

    const handleSelectOK = (wheres: any) => {
        setVisible(false);
    }
    useEffect(() => {
        refresh();
    }, [props.data]);
    return (
        <>
            <Overlay.Popup
                v2
                triggerType="click"

                placement="r"
                trigger={
                    <a
                        className="J_menuItem"
                        onClick={() => {
                            setVisible(!visible);
                        }}
                    >
                        <i
                            className="glyphicon glyphicon-th-large"
                            aria-hidden="true"
                        />
                        <span className="bef-menu-label">全部功能</span>
                    </a>
                }

                visible={visible}
                onVisibleChange={onVisibleChange}
            >
                <div style={{ paddingLeft: '25px', width: '772px', height: '90%' }} className="custom-left-menu">
                    <AllFunctions onOK={handleSelectOK} data={menuData}></AllFunctions>
                </div>
            </Overlay.Popup>

        </>
    );
}